import React from 'react';
import data from '../../../utils/tabsData.json';
import MobileWatch from '../../../assets/mobile_watch.svg';
import './CypherGlass.css';

interface CypherGlassProps {
  activeTab: string | null;
  activeSubTab: string | null;
}

const CypherGlass: React.FC<CypherGlassProps> = ({
  activeTab,
  activeSubTab,
}) => {
  const activeTabData = data.tabs.find((tab) => tab.id === activeTab);
  const subTabData = activeTabData?.subtabs.find((subtab) => subtab.id === activeSubTab);

  if (!activeTabData || !subTabData) return null;

  return (
    <div className="cypherGlass-container">
      {subTabData.products && (
        <div className="product-design-boxes">
          {subTabData.products.map((product) => (
            <div key={product.id} className="product-box-container">
              <div
                className="product-box"
                style={{
                  backgroundImage: product.image ? `url(${MobileWatch})` : 'none',
                  backgroundColor: product.image ? 'transparent' : '#42424233',
                }}
              ></div>
              <p className="product-label">{product.label.en}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CypherGlass;
